export default __webpack_public_path__ + "static/media/foreal_texture.280eadc0.jpg";